import { useEffect } from 'react';
import { useThemeStore } from '@/lib/stores/themeStore';

export function useTheme() {
  const { theme, mod, setTheme, toggleTheme, setMod } = useThemeStore();

  // Sincronizar data-theme no documento
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  // Sincronizar data-mod no documento
  useEffect(() => {
    document.documentElement.setAttribute('data-mod', mod);
  }, [mod]);

  return { theme, mod, setTheme, toggleTheme, setMod };
}
